import type {AccordionDetailsProps as MuiAccordionDetailsProps} from '@mui/material/AccordionDetails';
import MuiAccordionDetails from '@mui/material/AccordionDetails';
import {styled} from '@mui/material/styles';
import {forwardRef} from 'react';
import type {AccordionGlobalProps} from './Accordion';
import {excludeComponentProps} from '../utils/excludeComponentProps';

type BaseAccordionGlobalProps = Omit<MuiAccordionDetailsProps, 'variant' | 'children' | 'ref' | 'classes'>;

export interface AccordionDetailsProps extends BaseAccordionGlobalProps, AccordionGlobalProps {}

const StyledAccordionDetails = styled(MuiAccordionDetails, {
    ...excludeComponentProps('rightAligned', 'generatedId', 'dense')
})<AccordionDetailsProps>(({
    rightAligned, dense
}) => ({
    paddingTop: '0',
    paddingRight: '1rem',
    paddingBottom: '2rem',
    paddingLeft: '3rem', // (0.5rem padding) * 2 + (2rem button width)

    ...dense && {
        paddingRight: '0.75rem',
        paddingBottom: '1.5rem',
        paddingLeft: '2.5rem'
    },

    ...rightAligned && {
        paddingRight: '3rem',
        paddingLeft: '1.5rem',

        ...dense && {
            paddingRight: '2.5rem', // (0.25rem padding) * 2 + (2rem button width)
            paddingLeft: '1rem'
        }
    }
}));

export const AccordionDetails = forwardRef<HTMLDivElement, AccordionDetailsProps>(({
    generatedId, children, rightAligned, ...props
}, ref) => {
    return (
        <StyledAccordionDetails
            {...props}
            aria-labelledby={`${generatedId}-itemSummary`}
            id={`${generatedId}-itemDetails`}
            ref={ref}
            rightAligned={rightAligned}
        >
            {children}
        </StyledAccordionDetails>
    );
}
);

AccordionDetails.displayName = 'AccordionDetails';
